import { navigate } from 'gatsby';
import { mapLocaleToLanguage } from '../common/intl/utils/map-locale-to-language';
import { Language } from '../common/navigation/types/config';

export const LOCAL_STORAGE_LANG_KEY = `preferred_language`;
const DEFAULT_LANGUAGE: Language = `fr`;

export function redirectToPreferredLanguage(): void {
  // Make sure we're in a browser environment with localStorage available
  if (typeof window === `undefined` || typeof localStorage === `undefined`) {
    return;
  }

  // Only redirect if we're at the root path
  if (window.location.pathname !== `/`) {
    return;
  }

  try {
    const storedLanguage = localStorage.getItem(
      LOCAL_STORAGE_LANG_KEY,
    ) as Language | null;
    const targetLanguage =
      mapLocaleToLanguage(storedLanguage) || DEFAULT_LANGUAGE;
    console.log(`Redirecting to /${targetLanguage}`);
    navigate(`/${targetLanguage}`);
  } catch (error) {
    console.error(`Error during language redirect:`, error);
    navigate(`/${DEFAULT_LANGUAGE}`);
  }
}
